import http from '../http-engine';

export default {
  getOperationLogs(params) {
    return http.get('/api/v1/operationLogs', { params });
  },
  getOperationLogById(id) {
    return http.get(`/api/v1/operationLogs/${id}`, { });
  },
};
